import { Controller } from "@hotwired/stimulus";
import { i18n } from "../../utils/i18n";
import {
  createConfirmationModal,
  closeModal,
  showModal
} from "../../utils/modals";

export default class extends Controller {
  static values = {
    message: String,
    buttonClass: { type: String, default: "btn_primary" },
    title: String
  };

  connect() {
    // So our system specs know when the button is ready to be clicked
    // Add [data-confirm-ready] to the element selector in the spec or
    // SitePrismPage definition
    this.element.dataset.confirmReady = true;
  }

  open(e) {
    e.preventDefault();
    const content = this.messageValue;
    const okButtonClass = this.buttonClassValue;
    const title = this.titleValue || i18n.t("list_table.confirmation_title");

    const onConfirm = (() => {
      closeModal(this.modal);
      this.element.form.requestSubmit();
    }).bind(this);

    this.modal = createConfirmationModal({
      title,
      content,
      okButton: i18n.t("actions.ok"),
      okButtonClass,
      onConfirm
    });

    showModal(this.modal);

    this.modal.addEventListener("click", (event) => {
      if (this.modal.dataset.staticBackdrop !== undefined) return;
      if (this.modal !== event.target) return;
      closeModal(this.modal);
    });
  }
}
